import { useAppSelector } from './useAppSelector'

export const useNotifications = () =>
  useAppSelector((state) => state.notifications)
